import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
} from 'vue'

function useDialogManager(dialogName: string) {
  const dialogStack = ref<string[]>([])
  const isDialogOpened = computed(() => (
    dialogStack.value.includes(dialogName)
  ))

  function openDialog() {
    dialogStack.value.push(dialogName)
    window.history.pushState({ dialogStack: dialogStack.value }, '')
  }

  function closeDialog() {
    if (isDialogOpened.value) {
      dialogStack.value.pop()
      window.history.back()
    }
  }

  function updateDialogState() {
    dialogStack.value = window.history.state?.dialogStack || []
  }

  onMounted(() => {
    updateDialogState()
    window.addEventListener('popstate', updateDialogState)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('popstate', updateDialogState)
  })

  return { isDialogOpened, openDialog, closeDialog }
}

export default useDialogManager
